import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardUserService {
  currentUserName: string = ''
  constructor() { }
}
